import React, { useEffect, useState } from 'react'
import {
  CCard,
  CCardBody,
  CCol,
  CFormSelect,
  CRow,
  CSmartTable,
  CTable,
  CTableBody,
  CTableHead,
} from '@coreui/react-pro'
import PlayerService from 'src/service/PlayerService'
const RoundPlayerStatsIndoorTab = (props) => {
  const [statsData, setStatsData] = useState([])
  const handlePlayer = (e) => {
    const playerId = e.target.value
    PlayerService.playerStatsByRound(playerId).then((res) => {
      if (res.success) {
        setStatsData(res.data)
      }
    })
  }
  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol>
              <CFormSelect
                aria-label="Select player"
                name="player"
                className={'form-control'}
                onChange={handlePlayer}
                id="player"
              >
                <option value={0}>Select Player</option>
                {props.playerList &&
                  props.playerList.map((item, key) => (
                    <option value={item?.id} key={key}>
                      {item?.full_name}
                    </option>
                  ))}
              </CFormSelect>
              <div className="table-responsive">
                <CTable className="main-table table">
                  <CTableHead color="dark">
                    <tr>
                      <th>RD</th>
                      <th>FP</th>
                      <th>POS</th>
                      <th>RS</th>
                      <th>1S</th>
                      <th>2S</th>
                      <th>3S</th>
                      <th>4S</th>
                      <th>5S</th>
                      <th>6S</th>
                      <th>7S</th>
                      <th>8S</th>
                      <th>9S</th>
                      <th>OUTS</th>
                      <th>OVR</th>
                      <th>MDN</th>
                      <th>WKS</th>
                      <th>CS</th>
                      <th>CWK</th>
                      <th>STS</th>
                      <th>ROD</th>
                      <th>ROA</th>
                      <th>DKS</th>
                      <th>HT</th>
                    </tr>
                  </CTableHead>
                  <CTableBody>
                    {statsData &&
                      statsData.map((item, key) => (
                        <tr key={key}>
                          <td>{item.round}</td>
                          <td>{item.sum_fp}</td>
                          <td>{item.position_name}</td>
                          <td>{item?.sum_rs}</td>
                          <td>{item?.sum_ones}</td>
                          <td>{item?.sum_twos}</td>
                          <td>{item?.sum_threes}</td>
                          <td>{item?.sum_fours}</td>
                          <td>{item?.sum_fives}</td>
                          <td>{item?.sum_sixes}</td>
                          <td>{item?.sum_sevens}</td>
                          <td>{item?.sum_eights}</td>
                          <td>{item?.sum_nines}</td>
                          <td>{item?.sum_outs}</td>
                          <td>{item?.sum_overs}</td>
                          <td>{item?.sum_mdns}</td>
                          <td>{item?.sum_wks}</td>
                          <td>{item?.sum_cs}</td>
                          <td>{item?.sum_cwks}</td>
                          <td>{item?.sum_sts}</td>
                          <td>{item?.sum_rods}</td>
                          <td>{item?.sum_roas}</td>
                          <td>{item?.sum_dks}</td>
                          <td>{item?.sum_hattrick}</td>
                        </tr>
                      ))}
                    {statsData.length === 0 && (
                      <tr>
                        <td colSpan={15}>No record yet available.</td>
                      </tr>
                    )}
                  </CTableBody>
                </CTable>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default RoundPlayerStatsIndoorTab
